// extracted by mini-css-extract-plugin
module.exports = {"debug":"sectionTitle_debug__fcAeK","titleContainer":"sectionTitle_titleContainer__3YPcx"};